class FiltersProductSelect {
  form: HTMLFormElement
  select: HTMLSelectElement

  constructor(form: HTMLFormElement) {
    this.form = form
    this.select = this.form.querySelector(`[name^="post__in"]`) as HTMLSelectElement
  }

  setOptions(values: IAvailableBoatsForDates) {
    const defaultOption = this.select.firstElementChild
    this.select.innerHTML = ''

    if (defaultOption) this.createOption(`${defaultOption.textContent}`, '')

    values.forEach(value => {
      this.createOption(value.name, value.id)
    })
  }

  private createOption(label: string, value: string | number) {
    const option = document.createElement('option')

    option.text = label
    option.value = `${value}`

    this.select.add(option)

    return option
  }
}

export default FiltersProductSelect
